
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/forex/international-money-transfer",
      function () {
        return require("private-next-pages/forex/international-money-transfer.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/forex/international-money-transfer"])
      });
    }
  